import { useLingui } from "@lingui/react/macro";
import { userApi } from "@/lib/api/services/user.api";
import type { User } from "@/types/user";
import { EntitySelect } from "./EntitySelect";

function userLabel(u: User): string {
  const name = `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim();
  return name ? `${name} (${u.email})` : u.email;
}

export interface UserSelectProps {
  value: string | null | undefined;
  onChange: (value: string, user: User) => void;
  onClear?: () => void;
  isActive?: boolean;
  roleCode?: string;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function UserSelect({
  value,
  onChange,
  onClear,
  isActive,
  roleCode,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: UserSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<User>
      queryKeyBase={["entity-select", "users", isActive ?? null, roleCode ?? null]}
      fetchPage={({ page, limit, search }) =>
        userApi.paginate({ page, limit, search: search || undefined, isActive, roleCode })
      }
      getOptionValue={(u) => u.id}
      getOptionLabel={userLabel}
      fetchItem={(id) => userApi.getById(id)}
      value={value ?? ""}
      onChange={onChange}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a user...`}
      searchPlaceholder={t`Search users…`}
      emptyMessage={t`No users found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
